module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/covid19/pc/index/bg_link01-670c47cf55e7eca4573e419304e848c3.png";